import { IDocument } from '@faire/web-api--source/indigofair/data/IDocument';
import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';

export namespace IRetailerCreditReport {
  export namespace IExperianCreditReport {
    /**
     * Return an instance of IExperianCreditReport with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IExperianCreditReport>
    ): IExperianCreditReport =>
      ({
        ...(partial ?? {}),
      }) as IExperianCreditReport;
  }

  export interface IExperianCreditReport {
    credit_score: number | undefined;
    full_report_document: IDocument | undefined;
    full_report_profile_text: string | undefined;
  }

  export enum CreditReportStatus {
    CREDIT_REPORT_STATUS_UNKNOWN = 'CREDIT_REPORT_STATUS_UNKNOWN',
    VALID_CREDIT_SCORE = 'VALID_CREDIT_SCORE',
    FROZEN_CREDIT_SCORE = 'FROZEN_CREDIT_SCORE',
    INSUFFICIENT_CREDIT_SCORE = 'INSUFFICIENT_CREDIT_SCORE',
    NO_CREDIT_REPORT_FOUND = 'NO_CREDIT_REPORT_FOUND',
    REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
    TOO_MANY_RECORDS_CREDIT_SCORE = 'TOO_MANY_RECORDS_CREDIT_SCORE',
    SCC_BLOCKED_ON_POSSIBLE_FRAUDULENT_USER = 'SCC_BLOCKED_ON_POSSIBLE_FRAUDULENT_USER',
  }

  export enum CreditBureau {
    CREDIT_BUREAU_UNKNOWN = 'CREDIT_BUREAU_UNKNOWN',
    EXPERIAN = 'EXPERIAN',
    TRANSUNION = 'TRANSUNION',
  }

  export enum Purpose {
    PURPOSE_UNKNOWN = 'PURPOSE_UNKNOWN',
    OPEN_WITH_FAIRE = 'OPEN_WITH_FAIRE',
    ADMIN_INITIATED_FOR_OPEN_WITH_FAIRE = 'ADMIN_INITIATED_FOR_OPEN_WITH_FAIRE',
    NET_TERMS_LIMIT_INCREASE = 'NET_TERMS_LIMIT_INCREASE',
    FAIRE_PAY_LIMIT_INCREASE = 'FAIRE_PAY_LIMIT_INCREASE',
  }

  /**
   * Return an instance of IRetailerCreditReport with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRetailerCreditReport>
  ): IRetailerCreditReport =>
    ({
      ...(partial ?? {}),
    }) as IRetailerCreditReport;
}

export interface IRetailerCreditReport {
  /**
   * @protobufOption (.faire.common.tokenType) = RETAILER_CREDIT_REPORT
   */
  token: string | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = RETAILER
   */
  retailer_token: string | undefined;
  transunion_credit_score: number | undefined;
  updated_at: number | undefined;
  transunion_full_report_document: IDocument | undefined;
  open_with_faire_proposed_limit: IFaireMoney | undefined;
  experian_credit_report:
    | IRetailerCreditReport.IExperianCreditReport
    | undefined;
  status: keyof typeof IRetailerCreditReport.CreditReportStatus | undefined;
  credit_bureau: keyof typeof IRetailerCreditReport.CreditBureau | undefined;
}
